export const cardTableActionTypes = {
  loadMoreItems: '[Card table] - load more items',
};
